export enum HttpMethods {
  Get = 'get',
  Post = 'post',
  Put = 'put',
  Delete = 'delete'
}
